import { get, post, put } from 'utils/methods';

export function getOrderItemApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}items`, data, headers);
}

export function commentOrderItemApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/comment`, data, headers);
}

export function toggleOrderItemStatusApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/change-state`, data, headers);
}

export function getShippingTypeApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}shipping-types`, data, headers);
}

export function pushReprintApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/reprint`, data, headers);
}

export function pushStateApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/order-item/reprint/push`, data, headers);
}

export function reprintRequestApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/order-item/reprint/request`, data, headers);
}

export function reprintStateApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_PP}commands/order-item/reprint/state`, data, headers);
}
